import React from 'react';

import styles from '../../components/Map/Map.module.scss';

export const Map: React.FC<{
  long: number;
  lat: number;
  token?: string;
}> = ({ lat, long, token = '' }) => {
  const buildMapboxImageLink = `https://api.mapbox.com/styles/v1/payasugym/cju11lw2702jz1fmscy6vss9m/static/url-https%3A%2F%2Fstatic.hussle.com%2Fpins%2Fgym.png(${long},${lat})/${long},${lat},15,0/900x465?access_token=${token}`;

  return (
    <>
      <div className={styles['map']}>
        <img className={styles['map__image']} src={buildMapboxImageLink} loading="lazy" alt="Map of gym location" />
      </div>
    </>
  );
};

export default Map;
